export const formatGiftBalance = (minutes: number) => {
    const whole = Math.max(0, Math.floor(minutes));
    return `${Math.floor(whole / 60).toString().padStart(2, '0')}:${(whole % 60).toString().padStart(2, '0')}`;
};
